import React, {createContext, PropsWithChildren, useContext} from "react";
import { Container } from "../../../misc/Container";
import {ProjectProvider} from "../ProjectProvider";
import {SectionHeader} from "../../../misc/SectionHeader";
import {ProjectName} from "../shopdrawing/ProjectName";
import {QuoteNav} from "./QuoteNav";
import {deepPurple} from "@mui/material/colors";
import {QuoteAlternative} from "./QuoteAlternative";
import {ReloadContextProvider} from "../shopdrawing/hardware/ReloadContext";
import {CurrentContractorDisplay} from "./CurrentContractor";
import {AlternativeProvider} from "./alternative/AlternativeContext";
import {AlertProductRecalcHeader} from "../AlertProductRecalcHeader";

export const QuoteContext = createContext({
    isQuote: false,
})

export function useIsQuote() {
    return useContext(QuoteContext).isQuote;
}

const yesQuote = {
    isQuote: true,
}

export function QuoteContainer(props: PropsWithChildren<{
    actions?: any;
    overrideRightActions?: any;
    name: any;
}>) {
    return (
        <ProjectProvider>
            <AlternativeProvider>
                <ReloadContextProvider>
                    <QuoteContext.Provider value={yesQuote}>
                        <Container topCenter={<QuoteNav />} color={deepPurple["700"]}>
                            <div style={{
                                backgroundColor: "white",
                                overflow: "auto",
                                display: "flex",
                                flexDirection: "column",
                                flex: 1,
                            }}>
                                <SectionHeader name={props.name}
                                    inFromRight={props.actions}
                                    noPad
                                    right={
                                    <div style={{
                                        display: "flex",
                                        flexDirection: "row",
                                    }}>
                                        {props.overrideRightActions}
                                        <AlertProductRecalcHeader />

                                        <div style={{
                                            borderRadius: 0,
                                            paddingTop: 4,
                                            paddingBottom: 4,
                                            paddingLeft: 12,
                                            paddingRight: 12,
                                        }}>
                                            <div style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                alignItems: "center",
                                            }}>
                                                <ProjectName />
                                                <CurrentContractorDisplay />
                                            </div>
                                            <div>
                                                <QuoteAlternative />
                                            </div>
                                        </div>
                                    </div>}
                                />

                                {props.children}
                            </div>
                        </Container>
                    </QuoteContext.Provider>
                </ReloadContextProvider>
            </AlternativeProvider>
        </ProjectProvider>
    )
}